import { render, staticRenderFns } from "./ResourcePermissions.vue?vue&type=template&id=a99c1ff0"
import script from "./ResourcePermissions.vue?vue&type=script&lang=js"
export * from "./ResourcePermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports